import { defineMessages } from "react-intl";

import { Status } from "lib/build/forms/htx/patientCondition";

export const shortStatusMessages = defineMessages<Status>({
	[Status.NEW]: {
		id: "patient_status.short.new",
		defaultMessage: "ÚJ"
	},
	[Status.READY_FOR_COMMITTEE]: {
		id: "patient_status.short.ready_for_committee",
		defaultMessage: "BR"
	},
	[Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
		id: "patient_status.short.waiting_for_medical_examination",
		defaultMessage: "KVV"
	},
	[Status.TRANSPLANTABLE]: {
		id: "patient_status.short.transplantable",
		defaultMessage: "T"
	},
	[Status.NON_TRANSPLANTABLE]: {
		id: "patient_status.short.non_transplantable",
		defaultMessage: "NT"
	},
	[Status.NATIONAL_HIGH_URGENT]: {
		id: "patient_status.short.national_high_urgent",
		defaultMessage: "NHU"
	},
	[Status.HIGH_URGENT]: {
		id: "patient_status.short.high_urgent",
		defaultMessage: "HU"
	},
	[Status.UNSUITABLE]: {
		id: "patient_status.short.unsuitable",
		defaultMessage: "ALK"
	},
	[Status.HTX_DONE]: {
		id: "patient_status.short.htx_done",
		defaultMessage: "HTX"
	},
	[Status.EXIT]: {
		id: "patient_status.short.exit",
		defaultMessage: "EX"
	}
});

export const longStatusMessages = defineMessages<Status>({
	[Status.NEW]: {
		id: "patient_status.long.new",
		defaultMessage: "Új"
	},
	[Status.READY_FOR_COMMITTEE]: {
		id: "patient_status.long.ready_for_committee",
		defaultMessage: "Bizottsági Referálásra Kész"
	},
	[Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
		id: "patient_status.long.waiting_for_medical_examination",
		defaultMessage: "Kiegészítő Vizsgálatra Vár"
	},
	[Status.TRANSPLANTABLE]: {
		id: "patient_status.long.transplantable",
		defaultMessage: "Transzplantálható"
	},
	[Status.NON_TRANSPLANTABLE]: {
		id: "patient_status.long.non_transplantable",
		defaultMessage: "Nem Transzplantálható"
	},
	[Status.NATIONAL_HIGH_URGENT]: {
		id: "patient_status.long.national_high_urgent",
		defaultMessage: "Nemzeti High Urgent"
	},
	[Status.HIGH_URGENT]: {
		id: "patient_status.long.high_urgent",
		defaultMessage: "High Urgent"
	},
	[Status.UNSUITABLE]: {
		id: "patient_status.long.unsuitable",
		defaultMessage: "Alkalmatlan"
	},
	[Status.HTX_DONE]: {
		id: "patient_status.long.htx_done",
		defaultMessage: "HTX megtörtént"
	},
	[Status.EXIT]: {
		id: "patient_status.long.exit",
		defaultMessage: "Exit"
	}
});

export const waitingListMessages = defineMessages({
	waitingListDays: {
		id: "patient_status.waiting_list_days.title",
		defaultMessage: "{numberOfDays} napja várólistán"
	}
});
